import React, { Component } from 'react';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import {
	WithStyles,
	Grid,
} from '@material-ui/core';

import CourseDetailsDrawer from '../../course/components/CourseDetailsDrawer';
import LandingPage from '../components/landing_pages';
import courseService from '../services/courseService';
import {styles} from '../styling/WithNoContent'
import {CourseBasicInfo,CourseDetailDefault} from '../modals/CourseBasicInfo';

interface WithContentProps extends WithStyles<typeof styles> {
	courseListingData:any,
	isArchived: any,
}

interface WithContentStates {
	isDetailDrawerOpen: boolean,
	isFilterDrawerOpen:boolean,
	detailsData:CourseBasicInfo,	
}

class WithContent extends Component<WithContentProps, WithContentStates>{
	constructor(props:WithContentProps){
		super(props);
		this.state = {
			isDetailDrawerOpen: false,
			isFilterDrawerOpen: false,
			detailsData:CourseDetailDefault
		};

		this.handleDetailDrawerOpen = this.handleDetailDrawerOpen.bind(this);
		this.handleDetailDrawerClose = this.handleDetailDrawerClose.bind(this);
	}

	handleDetailDrawerOpen = (event:any,details:CourseBasicInfo) => {
		event.preventDefault();
		courseService.getPackageDetails(details._id).then((details: CourseBasicInfo) => {
			this.setState({
				isDetailDrawerOpen: true,
				detailsData:details
			});
		});
		
	};

	handleDetailDrawerClose = (event:any) => {
		
		this.setState({
			isDetailDrawerOpen: false,
		});
	};

	
	render() {
		const { isDetailDrawerOpen } = this.state;
		const { classes ,courseListingData, isArchived} = this.props;
		

		return (
			<>
				<Grid container>
				<Grid item xs={1}></Grid>
						<Grid item xs={10}>
						<Grid container className={classes.paddingLeft}>
							<Grid item xs={12}>
							<LandingPage
								 courseListingData = {courseListingData}
								 onViewDetailsClick={this.handleDetailDrawerOpen.bind(this)}
									isArchived={isArchived}
								  />
							</Grid>
						</Grid>
					</Grid>
				</Grid>
				<CourseDetailsDrawer
					onDetailDrawerClose={this.handleDetailDrawerClose.bind(this)}
					isDetailsDrawerOpen={isDetailDrawerOpen}
					drawerData = {this.state.detailsData}
				/>
			</>
    );
	}
}

// @ts-ignore
export default withStyles(styles)(WithContent);


